var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "33.813px",
    height: "31.75px",
    viewBox: "0 0 33.813 31.75",
    enableBackground: "new 0 0 33.813 31.75",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4638_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4648_",
    fill: "#4D4BB6",
    d: "M23.657,1.413H9.032c-1.382,0-2.505,1.124-2.505,2.505v23.916 c0,1.381,1.123,2.504,2.505,2.504h14.625c1.382,0,2.505-1.123,2.505-2.504V3.918C26.162,2.537,25.039,1.413,23.657,1.413z  M25,27.834c0,0.74-0.602,1.342-1.343,1.342H9.032c-0.741,0-1.343-0.602-1.343-1.342V3.918c0-0.74,0.602-1.343,1.343-1.343h14.625 C24.398,2.575,25,3.178,25,3.918V27.834z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_4647_",
    fill: "#4D4BB6",
    cx: 16.345,
    cy: 2.911,
    r: 0.269
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4646_",
    fill: "#4D4BB6",
    d: "M15.336,4.265h2.018c0.147,0,0.268-0.121,0.268-0.269c0-0.147-0.12-0.268-0.268-0.268 h-2.018c-0.147,0-0.268,0.12-0.268,0.268C15.068,4.145,15.188,4.265,15.336,4.265z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_4645_",
    fill: "#4D4BB6",
    cx: 14.436,
    cy: 3.997,
    r: 0.209
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4642_",
    fill: "#4D4BB6",
    d: "M16.345,25.793c-0.903,0-1.638,0.734-1.638,1.639c0,0.902,0.734,1.637,1.638,1.637 s1.638-0.734,1.638-1.637C17.982,26.527,17.248,25.793,16.345,25.793z M16.345,28.486c-0.582,0-1.057-0.473-1.057-1.055 c0-0.583,0.475-1.057,1.057-1.057c0.583,0,1.057,0.474,1.057,1.057C17.401,28.014,16.928,28.486,16.345,28.486z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4639_",
    fill: "#4D4BB6",
    d: "M23.206,4.844H9.484c-0.16,0-0.291,0.13-0.291,0.291v20.326 c0,0.16,0.131,0.291,0.291,0.291h13.722c0.16,0,0.29-0.131,0.29-0.291V5.135C23.496,4.975,23.366,4.844,23.206,4.844z  M22.915,25.17H9.774V5.425h13.141V25.17z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoap);
export default __webpack_public_path__ + "static/media/moap.124e6bf389a42fed920e7f1ea46279f5.svg";
export { ForwardRef as ReactComponent };